import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  root: {
    padding: '22px',
  },
});
